/* @flow */
import gql from 'graphql-tag';

export const fragments = {
    searchResult: gql`
        fragment FilterCountsSearchResult on SearchResult {
            id
            resultCount
            filterGroups {
                groupInfo {
                    name
                    id
                }
                filters {
                    count @include(if: $filterCounts)
                    checked
                    filter {
                        id
                        name
                        refineByQueryArgument
                        description
                    }
                }
            }
        }
    `
};

export const FILTER_COUNT_SEARCH_QUERY_NAME = 'SearchFilterCountQuery';

export const filteredSearchCountQuery = gql`
    query ${FILTER_COUNT_SEARCH_QUERY_NAME}($request: SearchResultRequest!, $filterCounts: Boolean! ) {
        results: search(request: $request) {
            ...FilterCountsSearchResult
        }
    }
    ${fragments.searchResult}
`;
